import { jsx as _jsx } from "react/jsx-runtime";
const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.4em',
    padding: '0.5em 1em',
    borderRadius: 'var(--radius-button, 8px)',
    border: '1px solid transparent',
    font: 'inherit',
    fontWeight: 600,
    lineHeight: 1.2,
    cursor: 'pointer',
    minHeight: 40,
};
const variantStyles = {
    primary: { background: 'var(--color-brand-orange, #F48C06)', color: '#ffffff', borderColor: 'var(--color-brand-orange, #F48C06)' },
    secondary: { background: 'var(--color-brand-green, #1B4332)', color: '#ffffff', borderColor: 'var(--color-brand-green, #1B4332)' },
};
const disabledStyle = { opacity: 0.6, cursor: 'not-allowed' };
/**
 * Accessible button. Forwards all native button attributes (`onClick`,
 * `disabled`, `aria-*`, etc.).
 */
export function Button({ variant = 'primary', block = false, type = 'button', style, disabled, children, ...rest }) {
    return (_jsx("button", { 
        // `type` defaults to "button" above; it is always a valid button type here.
        type: type, disabled: disabled, style: {
            ...baseStyle,
            ...variantStyles[variant],
            ...(block ? { width: '100%' } : null),
            ...(disabled ? disabledStyle : null),
            ...style,
        }, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map